import {pageInfo, exportData, downloadFile, importData, importOrder, downloadTemplate, downloadTemplateById, listTemplate} from './../api';
import { Message } from 'element-ui';
import {listShipper, listCompany, listCompanyByShipperCode} from "../../../../api";
const orderImport = {
  namespaced: true,
  state: {
    total: 0,
    pageResp: null,
    exportDataObj: null,
    downloadFileObj: null,
    importDataObj: null,
    importOrderObj: null,
    downloadTemplateByIdObj: null,
    downloadTemplateObj: null,
    shipperObj: null,
    companyObj: null,
    templateDataObj: null,
    companyDataObj: null
  },
  mutations: {
    PAGE_INFO(state, data) {
      state.total = data.total;
      state.pageResp = (data.obj || []).map(item => ({
        ...item,
        dealStatusShowColor: item.dealStatus === '处理失败' || undefined,
        dealStatusColor: item.dealStatus === '处理失败' ? 'red' : undefined,
      }));
    },
    EXPORT_DATA(state, data) {
      state.exportDataObj = data;
    },
    DOWNLOAD_FILE(state, data) {
      state.downloadFileObj = data;
    },
    IMPORT_DATE(state, data) {
      state.importDataObj = data;
    },
    IMPORT_ORDER(state, data) {
      state.importOrderObj = data;
    },
    DOWNLOAD_TEMPLATE_BY_ID(state, data) {
      state.downloadTemplateByIdObj = data;
    },
    DOWNLOAD_TEMPLATE(state, data) {
      state.downloadTemplateObj = data;
    },
    LIST_SHIPPER(state, data) {
      state.shipperObj = data.obj;
    },
    LIST_COMPANY(state, data) {
      state.companyObj = data.obj;
    },
    LIST_TEMPLATE(state, data) {
      state.templateDataObj = data;
    },
    LIST_COMPANY_BY_SHIPPERCODE(state, data) {
      state.companyDataObj = data;
    },
  },
  actions: {
    //查询
    async pageInfo({ commit }, obj) {
      let resp = await pageInfo(obj);
      commit('PAGE_INFO', resp);
    },
    //导出文件
    async exportData({ commit }, obj) {
      let resp = await exportData(obj);
      commit('EXPORT_DATA', resp);
    },
    //下载文件
    async downloadFile({ commit }, obj) {
      let resp = await downloadFile(obj);
      commit('DOWNLOAD_FILE', resp);
    },
    //导入文件
    async importData({ commit }, obj) {
      let resp = await importData(obj);
      commit('IMPORT_DATE', resp);
    },
    //动态导入文件
    async importOrder({ commit }, obj) {
      let resp = await importOrder(obj);
      commit('IMPORT_ORDER', resp);
    },
    //动态下载模板
    async downloadTemplateById({ commit }, obj) {
      let resp = await downloadTemplateById(obj);
      commit('DOWNLOAD_TEMPLATE_BY_ID', resp);
    },
    //下载模版
    async downloadTemplate({ commit }, obj) {
      let resp = await downloadTemplate(obj);
      commit('DOWNLOAD_TEMPLATE', resp);
    },
    //货主downloadTemplate
    async listShipper({ commit }, obj) {
      let resp = await listShipper(obj);
      commit('LIST_SHIPPER', resp);
    },
    //机构
    async listCompany({ commit }, obj) {
      let resp = await listCompany(obj);
      commit('LIST_COMPANY', resp);
    },
    /**
     * 下拉框模版数据
     * @param commit
     * @param obj
     * @returns {Promise<void>}
     */
    async selectTemplate({ commit }, obj) {
      let resp = await listTemplate(obj);
      commit('LIST_TEMPLATE', resp);
    },
    /**
     * 根据货主查询所属机构下拉框数据
     * @param commit
     * @param obj
     * @returns {Promise<void>}
     */
    async listCompanyByShipperCode({ commit }, obj) {
      let resp = await listCompanyByShipperCode(obj);
      commit('LIST_COMPANY_BY_SHIPPERCODE', resp);
    },
  }
}
export default orderImport



// WEBPACK FOOTER //
// ./src/page/order/orderImport/store/orderImport.store.js